/*
 * QuestionFooter Messages
 *
 * This contains all the text for the QuestionFooter component.
 */
import { defineMessages } from 'react-intl';
import {
  REASON_SCREENOUT,
  REASON_PROFILING,
  REASON_QUALITY,
  REASON_SCREENING_QUOTA_FULL,
  REASON_QUESTIONNAIRE_QUOTA_FULL,
} from 'components/LogicOutcome/constants';

export const scope = 'app.components.QuestionFooter';

export default defineMessages({
  noneOfTheAboveLabel: {
    id: `${scope}.noneOfTheAboveLabel`,
    defaultMessage: 'None...',
  },
  otherLabel: {
    id: `${scope}.otherLabel`,
    defaultMessage: 'Other',
  },
  goesToLabel: {
    id: `${scope}.goesToLabel`,
    defaultMessage: 'Goes to:',
  },
  withLoopLabel: {
    id: `${scope}.withLoopLabel`,
    defaultMessage:
      'The logic in this question creates a loop. Respondents will not be able to finish the survey.',
  },
  comesFromLabel: {
    id: `${scope}.comesFromLabel`,
    defaultMessage: 'Comes from:',
  },
  otherTooltip: {
    id: `${scope}.otherTooltip`,
    defaultMessage: 'Includes "Other" as answer',
  },
  noneOfAboveTooltip: {
    id: `${scope}.noneOfAboveTooltip`,
    defaultMessage: 'Includes "None of the above" as answer',
  },
  noneOfTheseTooltip: {
    id: `${scope}.noneOfTheseTooltip`,
    defaultMessage: 'Includes "None of these" as answer',
  },
  shuffleTooltip: {
    id: `${scope}.shuffleTooltip`,
    defaultMessage: 'Shuffle answers is enabled',
  },
  shuffleQuestionsTooltip: {
    id: `${scope}.shuffleQuestionsTooltip`,
    defaultMessage: 'Shuffle questions is enabled',
  },
  mediaTooltip: {
    id: `${scope}.mediaTooltip`,
    defaultMessage: 'Has media enabled',
  },
  ratingTooltip: {
    id: `${scope}.ratingTooltip`,
    defaultMessage: 'Number of stars',
  },
  carryForwardTooltip: {
    id: `${scope}.carryForwardTooltip`,
    defaultMessage: 'Has carry forward enabled',
  },
  limitAnswersTooltip: {
    id: `${scope}.limitAnswersTooltip`,
    defaultMessage: 'Limit answers is enabled',
  },
  endOfSurvey: {
    id: `${scope}.endOfSurvey`,
    defaultMessage: 'End of survey',
  },
  endOfSurveyReason: {
    [REASON_SCREENOUT]: {
      id: `${scope}.endOfSurveyReason.${REASON_SCREENOUT}`,
      defaultMessage: 'screen-out',
    },
    [REASON_PROFILING]: {
      id: `${scope}.endOfSurveyReason.${REASON_PROFILING}`,
      defaultMessage: 'profiling termination',
    },
    [REASON_QUALITY]: {
      id: `${scope}.endOfSurveyReason.${REASON_QUALITY}`,
      defaultMessage: 'quality termination',
    },
    [REASON_SCREENING_QUOTA_FULL]: {
      id: `${scope}.endOfSurveyReason.${REASON_SCREENING_QUOTA_FULL}`,
      defaultMessage: 'screening quota full',
    },
    [REASON_QUESTIONNAIRE_QUOTA_FULL]: {
      id: `${scope}.endOfSurveyReason.${REASON_QUESTIONNAIRE_QUOTA_FULL}`,
      defaultMessage: 'question quota full',
    },
  },
  skippedQuestionTooltip: {
    id: `${scope}.skippedQuestionTooltip`,
    defaultMessage:
      'Please update the questionnaire logic or remove this question.',
  },
  skippedQuestion: {
    id: `${scope}.skippedQuestion`,
    defaultMessage: 'Skipped question',
  },
  skippedGroupTooltip: {
    id: `${scope}.skippedGroupTooltip`,
    defaultMessage:
      'Please update the questionnaire logic or remove this group.',
  },
  skippedGroup: {
    id: `${scope}.skippedGroup`,
    defaultMessage: 'Skipped group',
  },
  wrongReferenceTooltip: {
    id: `${scope}.wrongReferenceTooltip`,
    defaultMessage: 'A rule references a question that might be skipped.',
  },
  hiddenAnswerReferenceTooltip: {
    id: `${scope}.hiddenAnswerReferenceTooltip`,
    defaultMessage: 'A rule references an answer that will be removed.',
  },
  wrongReference: {
    id: `${scope}.wrongReference`,
    defaultMessage: 'Review logic',
  },
  wrongDisplayLogicReference: {
    id: `${scope}.wrongDisplayLogicReference`,
    defaultMessage: 'Review display logic',
  },
  wrongVariablesLogicReference: {
    id: `${scope}.wrongVariablesLogicReference`,
    defaultMessage: 'Review hidden variables logic',
  },
  skippedCarryForwardTooltip: {
    id: `${scope}.skippedCarryForwardTooltip`,
    defaultMessage:
      'Please update the questionnaire logic or remove the skipped carried forward question.',
  },
  skippedCarryForward: {
    id: `${scope}.skippedCarryForward`,
    defaultMessage: 'Skipped carry forward',
  },
  advancedQuotas: {
    id: `${scope}.advancedQuotas`,
    defaultMessage: 'Conditional quotas',
  },
  quotasFulfilled: {
    id: `${scope}.quotasFulfilled`,
    defaultMessage: 'Quotas fulfilled',
  },
});
